// removed by extract-text-webpack-plugin
module.exports = {"user_info":"index_3mQ43NM","collect":"index_2720pmT"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/user/bookrack/index.css
// module id = 1052
// module chunks = 0